<section class="top-page-margin">
  <gds-spacer classes="spacer-130"></gds-spacer>
  <div class="row">
    <div class="small-12 medium-2 columns">
      <div class="club-universal-btn">
        <gds-utility-action
          [data]="{
            icon: {
              iconName: 'left-arrow-v2',
            },
            label: pageLabels?.['linkReservations.LinkReservationsBackCTA'],
            type: 'left-arrow-v2',
            disabled: false,
          }"
          (utilityClicked)="goToLinkReservations()"
        ></gds-utility-action>
      </div>
    </div>
    <gds-spacer classes="spacer-90"></gds-spacer>
    <div uprInheritStyle>
      <gds-content-feature
        [data]="{
          image: {
            mobile: errorImage,
            tablet: errorImage,
            desktop: errorImage,
            alt: pageLabels['com.udx.unable_to_retrieve_reservation.imageAlt'],
          },
          tagType: 'h1',
          heading: pageLabels['linkReservation.linking_error_title'],
          description: pageLabels['linkReservation.linking_error_description2'],
          buttons: [
            {
              type: 'secondary',
              label: pageLabels['linkReservation.try_again.cta'],
            },
            {
              type: 'tertiary',
              label: pageLabels['linkReservation.txtCancel'],
            },
          ],
        }"
        (buttonClicked)="buttonEventHandler($event)"
      >
      </gds-content-feature>
    </div>
  </div>
</section>
